import {
    SET_SEARCH_SPACE,
    SET_ARTICLE_FLAG,
    SET_PINNED_ARTICLES,
    SET_SAVED_DOCUMENTS,
    SET_TEMP_REMOVED_DOCUMENTS,
    SET_SPACES_LIST,
    SET_SEARCH_SPACE_TAB_STATUS,
    SET_SEARCH_SPACE_DESCRIPTION
} from '../../actions';

const initialState = {
    searchSpace: null,
    spaceList: [],
    articleFlag: false,
    pinnedArticles: [],
    savedDocuments: [],
    removedDocuments: [],
    searchSpaceTabStatus: false,
    searchSpaceDescription: null
}

function searchSpaceReducer(state = initialState, action ) {
    switch (action.type) {
        case SET_SEARCH_SPACE:
            if (JSON.stringify(state.searchSpace) === JSON.stringify(action.searchSpace)) {
                return state;
            }

            return {
                ...state,
                searchSpace: action.searchSpace
            };
        
        case SET_SPACES_LIST:
            if (JSON.stringify(state.spaceList) === JSON.stringify(action.spaceList)) {
                return state;
            }

            return {
                ...state,
                spaceList: action.spaceList
            };
        
        case SET_ARTICLE_FLAG:
            if (JSON.stringify(state.articleFlag) === JSON.stringify(action.articleFlag)) {
                return state;
            }

            return {
                ...state,
                articleFlag: action.articleFlag
            };

        case SET_PINNED_ARTICLES:
            if (JSON.stringify(state.pinnedArticles) === JSON.stringify(action.pinnedArticles)) {
                return state;
            }

            return {
                ...state,
                pinnedArticles: action.pinnedArticles
            };
        
        case SET_SAVED_DOCUMENTS:
            if (JSON.stringify(state.savedDocuments) === JSON.stringify(action.savedDocuments)) {
                return state;
            }

            return {
                ...state,
                savedDocuments: action.savedDocuments
            };

        case SET_TEMP_REMOVED_DOCUMENTS:
            if (JSON.stringify(state.removedDocuments) === JSON.stringify(action.removedDocuments)) {
                return state;
            }

            return {
                ...state,
                removedDocuments: action.removedDocuments
            };

        case SET_SEARCH_SPACE_TAB_STATUS:
            if (JSON.stringify(state.searchSpaceTabStatus) === JSON.stringify(action.searchSpaceTabStatus)) {
                return state;
            }

            return {
                ...state,
                searchSpaceTabStatus: action.searchSpaceTabStatus
            };

        case SET_SEARCH_SPACE_DESCRIPTION:
            if (JSON.stringify(state.searchSpaceDescription) === JSON.stringify(action.searchSpaceDescription)) {
                return state;
            }

            return {
                ...state,
                searchSpaceDescription: action.searchSpaceDescription
            };
        
        default:
            return state;

    }
}

export default searchSpaceReducer;
